<div class="modal fade" tabindex="-1" role="dialog" id="relatorio-kardex-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'estoque.relatorioKardex.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!--      <div class="modal-body">-->
      <div class="container striped-rows">
        <div class="row ptb5">
          <div translate class="col col-4">
            PartNumber
          </div>
          <div class="col col-8">
            <input class="form-control form-control-sm" type="text"
              placeholder="{{'estoque.relatorioKardex.filtros.partNumberPlaceHolder' | translate}}"
              [(ngModel)]="filtros.part_number"
              [required]="valorRetornado === 'peca_rede'">
          </div>
        </div>
        <div class="row ptb5" *ngIf="valorRetornado !== 'peca_rede'">
          <div translate class="col col-4">
            {{'estoque.relatorioKardex.filtros.grupoEconomico'}}
          </div>
          <div class="col col-8" name="GrupoEconomico">
            <select class="form-control form-control-sm" type="text" (change)="selecionaDealer()"
              [(disabled)]="habGrupoEconomico" [(ngModel)]="GrupoEconomico"
              placeholder="Selecione o grupo econômico...">
              <option translate value="">{{'estoque.relatorioKardex.filtros.grupoEconomicoPlaceHolder'}}</option>
              <option *ngFor="let item of gruposEconomicos" [value]="item.id"> {{item.descricao}} </option>
            </select>
          </div>
        </div>
        <div class="row ptb5" *ngIf="valorRetornado !== 'peca_rede'">
          <div translate class="col col-4">
            {{'estoque.relatorioKardex.filtros.dealer'}}
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
              <option translate value="">{{'estoque.relatorioKardex.filtros.dealerPlaceHolder'}}</option>
              <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5" *ngIf="valorRetornado === 'kardex'">
          <div translate class="col col-4">
            {{'estoque.relatorioKardex.filtros.mesInicial'}}
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês inicial..."
              [(ngModel)]="filtros.mes_inicial" [(ngModel)]="mes_inicial">
              <option translate value=1>{{'estoque.relatorioKardex.filtros.meses.janeiro'}}</option>
              <option translate value=2>{{'estoque.relatorioKardex.filtros.meses.fevereiro'}}</option>
              <option translate value=3>{{'estoque.relatorioKardex.filtros.meses.marco'}}</option>
              <option translate value=4>{{'estoque.relatorioKardex.filtros.meses.abril'}}</option>
              <option translate value=5>{{'estoque.relatorioKardex.filtros.meses.maio'}}</option>
              <option translate value=6>{{'estoque.relatorioKardex.filtros.meses.junho'}}</option>
              <option translate value=7>{{'estoque.relatorioKardex.filtros.meses.julho'}}</option>
              <option translate value=8>{{'estoque.relatorioKardex.filtros.meses.agosto'}}</option>
              <option translate value=9>{{'estoque.relatorioKardex.filtros.meses.setembro'}}</option>
              <option translate value=10>{{'estoque.relatorioKardex.filtros.meses.outubro'}}</option>
              <option translate value=11>{{'estoque.relatorioKardex.filtros.meses.novembro'}}</option>
              <option translate value=12>{{'estoque.relatorioKardex.filtros.meses.dezembro'}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5" *ngIf="valorRetornado === 'kardex'">
          <div translate class="col col-4">
            {{'estoque.relatorioKardex.filtros.mesFinal'}}
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o mês final..."
              [(ngModel)]="filtros.mes_final" [(ngModel)]="mes_final">
              <option translate value=1>{{'estoque.relatorioKardex.filtros.meses.janeiro'}}</option>
              <option translate value=2>{{'estoque.relatorioKardex.filtros.meses.fevereiro'}}</option>
              <option translate value=3>{{'estoque.relatorioKardex.filtros.meses.marco'}}</option>
              <option translate value=4>{{'estoque.relatorioKardex.filtros.meses.abril'}}</option>
              <option translate value=5>{{'estoque.relatorioKardex.filtros.meses.maio'}}</option>
              <option translate value=6>{{'estoque.relatorioKardex.filtros.meses.junho'}}</option>
              <option translate value=7>{{'estoque.relatorioKardex.filtros.meses.julho'}}</option>
              <option translate value=8>{{'estoque.relatorioKardex.filtros.meses.agosto'}}</option>
              <option translate value=9>{{'estoque.relatorioKardex.filtros.meses.setembro'}}</option>
              <option translate value=10>{{'estoque.relatorioKardex.filtros.meses.outubro'}}</option>
              <option translate value=11>{{'estoque.relatorioKardex.filtros.meses.novembro'}}</option>
              <option translate value=12>{{'estoque.relatorioKardex.filtros.meses.dezembro'}}</option>
            </select>
          </div>
        </div>
        <div class="row ptb5" *ngIf="valorRetornado === 'kardex'">
          <div translate class="col col-4">
            {{'estoque.relatorioKardex.filtros.ano'}}
          </div>
          <div class="col col-8">
            <select class="form-control form-control-sm" type="text" placeholder="Selecione o Ano..."
              [(ngModel)]="filtros.ano" [(ngModel)]="ano">
              <option *ngFor="let ano of anoDropDown" value={{ano.value}}>{{ano.value}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="limpaFiltro()">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>
